import { render, staticRenderFns } from "./SelectNamingValueDropdown.vue?vue&type=template&id=3b744e96"
import script from "./SelectNamingValueDropdown.vue?vue&type=script&lang=js"
export * from "./SelectNamingValueDropdown.vue?vue&type=script&lang=js"
import style0 from "./SelectNamingValueDropdown.vue?vue&type=style&index=0&id=3b744e96&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs_testing/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b744e96')) {
      api.createRecord('3b744e96', component.options)
    } else {
      api.reload('3b744e96', component.options)
    }
    module.hot.accept("./SelectNamingValueDropdown.vue?vue&type=template&id=3b744e96", function () {
      api.rerender('3b744e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/LayoutSettingsModal/SelectNamingValueDropdown.vue"
export default component.exports